import { cn } from '@/lib/utils'

export default function GridToolbarContainer({
    sx = {},
    children,
    className,
    hidden = false,
}: {
    sx?: React.CSSProperties
    children: React.ReactNode
    className?: string
    hidden?: boolean
}) {
    if (hidden) return null
    return (
        <div
            className={cn(
                'flex justify-between items-center p-1 px-2 flex-wrap',
                sx.height ? '' : 'min-h-[3.5rem] h-fit',
                'border-x border-t bg-inherit border-inherit',
                'rounded-t-[0.38rem] rounded-b-none',
                className,
            )}
            style={sx}
        >
            {children}
        </div>
    )
}
